import React from "react";
import CustomButton from "../CustomButton";
import NotifsIcon from "../../../media/images/icons/notification-bing";
import { Box, Typography, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../hooks/useRedux";

interface Props {
  path: string;
}
export default function NotifSingleButton(props: Props) {
  const { path } = props;
  const theme = useTheme();
  const navigate = useNavigate();

  const { messages } = useAppSelector((state) => state.settings);

  return (
    <Box
      sx={{
        position: "relative",
      }}
    >
      {!!messages?.length && (
        <Box
          sx={{
            zIndex: "500",
            position: "absolute",
            top: "-4px",
            width: "18px",
            height: "18px",
            backgroundColor: "secondary.main",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography
            sx={{
              fontSize: "12px",
              color: "#fff",
            }}
          >
            {messages.length > 99 ? `+99` : messages.length}
          </Typography>
        </Box>
      )}

      <CustomButton
        onClick={() => navigate(path)}
        bgColor={theme.palette.secondary[50]}
        rippleColor={theme.palette.secondary.main}
        gap="0px"
        height="fit-content"
        fSize="16px"
        borderColor={theme.palette.secondary[600]}
        fWeight="700"
        px="6px"
        py="6px"
        borderRadius="10px"
        icon2={<NotifsIcon size={26} color={theme.palette.secondary[600]} />}
      />
    </Box>
  );
}
